import { render, staticRenderFns } from "./services.vue?vue&type=template&id=f48e5f84&scoped=true&"
import script from "./services.vue?vue&type=script&lang=js&"
export * from "./services.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48e5f84",
  null
  
)

export default component.exports